import { ActionButton, Stack, TooltipHost } from '@fluentui/react';
import React, { useState } from 'react';
import { useId } from '@fluentui/react-hooks';
import { ListFilterCallout } from './ListFilterCallout';
import { filterOptionProps } from 'documents/documentAssignment/folder/list/GroupHeader';
import { FilterBadge } from 'common/components/FilterBadge';
export interface ListFiltersProps {
  filterOptions: filterOptionProps;
  documentPoolId: string;
  onFilterChange: (filterOptions: filterOptionProps) => void;
}

export const ListFilters: React.FC<ListFiltersProps> = ({
  documentPoolId,
  ...props
}) => {
  const calloutId = useId(`filter-callOutId${documentPoolId}`);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const filterToggle = () => setFiltersApplied((prevState) => !prevState);

  const filtersCount = props.filterOptions?.filterTypes?.length;

  const filtersNumber = filtersCount;

  return (
    <Stack horizontal>
      <TooltipHost content={filtersApplied ? 'Close filters' : 'Open Filters'}>
        <FilterBadge visible={filtersNumber > 0} filtersCount={filtersNumber}>
          <ActionButton
            onClick={filterToggle}
            id={calloutId}
            iconProps={{ iconName: filtersApplied ? 'ClearFilter' : 'Filter' }}
            text="Filters"
          />
        </FilterBadge>
      </TooltipHost>
      {filtersApplied && (
        <ListFilterCallout
          onDismiss={filterToggle}
          calloutId={calloutId}
          {...props}
        />
      )}
    </Stack>
  );
};
